import request from '@/utils/request'

export function updateUserPassword(data) {
  return request({
    url: '/auth/change-password',
    method: 'post',
    data: data
  })
}

export function forgetUserPassword(data) {
  return request({
    url: '/public/auth/reset-password',
    method: 'post',
    data: data
  })
}

export function registerUser(data) {
  return request({
    url: '/public/auth/register',
    method: 'post',
    data: data
  })
}

export function sendUserCode(data) {
  return request({
    url: '/public/auth/send-code',
    method: 'post',
    data: data,
    params:data
  })
}

export function updateUserCode(data) {
  return request({
    url: '/auth/update-info',
    method: 'post',
    data: data,
    params:data
  })
}

export function getUserInfoList(params) {
  return request({
    url: '/user/v1/query/info/byAccount',
    method: 'get',
    params
  })
}
